import { PaymentsNegativation } from "./paymentCalculations.helper";

/**
 * Adiciona ou remove um pagamento da seleção
 * @param selectedPayments Array atual de pagamentos selecionados
 * @param payment Pagamento a ser adicionado/removido
 * @returns Novo array com o pagamento adicionado ou removido
 */
export const togglePaymentSelection = (
  selectedPayments: PaymentsNegativation[],
  payment: PaymentsNegativation
): PaymentsNegativation[] => {
  const index = selectedPayments.findIndex((selected) => selected._id === payment._id);

  if (index === -1) {
    // Payment not selected, add it
    return [...selectedPayments, payment];
  } else {
    // Payment already selected, remove it
    const newSelected = [...selectedPayments];
    newSelected.splice(index, 1);
    return newSelected;
  }
};

/**
 * Verifica se todos os pagamentos estão selecionados
 * @param selectedPayments Array de pagamentos selecionados
 * @param allPayments Array de todos os pagamentos disponíveis
 * @returns true se todos estão selecionados
 */
export const areAllPaymentsSelected = (
  selectedPayments: PaymentsNegativation[],
  allPayments: PaymentsNegativation[]
): boolean => {
  return selectedPayments.length === allPayments.length && allPayments.length > 0;
};

/**
 * Verifica se alguns (mas não todos) pagamentos estão selecionados
 * @param selectedPayments Array de pagamentos selecionados
 * @param allPayments Array de todos os pagamentos disponíveis
 * @returns true se alguns estão selecionados
 */
export const areSomePaymentsSelected = (
  selectedPayments: PaymentsNegativation[],
  allPayments: PaymentsNegativation[]
): boolean => {
  return selectedPayments.length > 0 && selectedPayments.length < allPayments.length;
};

export const togglePayment = <T extends { _id: string }>(
  selectedPayments: T[],
  payment: T
): T[] => {
  const index = selectedPayments.findIndex((selected) => selected._id === payment._id);

  if (index === -1) {
    // Payment not selected, add it
    return [...selectedPayments, payment];
  } else {
    // Payment already selected, remove it
    const newSelected = [...selectedPayments];
    newSelected.splice(index, 1);
    return newSelected;
  }
};
